import type {
  PaymentsCard,
  PaymentsCardMetadata
} from '@library/types/payments';
import {
  formatWithTimezoneChange,
  getPaymentsDateTime
} from '@library/utils/dateTime';
import { useMemo } from 'react';

// Possible card types from the paysafe api
// https://developer.paysafe.com/en/payments-api/#/schemas/card
const CARD_TYPE_NAME_MAP: Record<PaymentsCardMetadata['type'], string> = {
  AM: 'American Express',
  DI: 'Discover',
  JC: 'JCB',
  MC: 'Mastercard',
  MD: 'Maestro',
  SO: 'Solo',
  VI: 'Visa',
  VD: 'Visa Debit',
  VE: 'Visa Electron'
};

export const useNormalizedMethodData = (method: PaymentsCard) => {
  let deletedBy = '';

  if (method.whoDunnit.deletedByAdminEmail) {
    deletedBy = method.whoDunnit.deletedByAdminEmail;
  } else if (method.deletedAt) {
    deletedBy = 'User';
  }

  const data = useMemo(() => {
    return {
      exp: `${method.card.expiryMonth}/${method.card.expiryYear}`,
      type: CARD_TYPE_NAME_MAP[method.card.type],
      name: `${method.name.first} ${method.name.last}`,
      zip: method.address.zip,
      lastDigits: method.card.lastDigits,
      status: method.deletedAt ? 'DELETED' : method.status,
      deletedAt: method.deletedAt
        ? formatWithTimezoneChange(
            getPaymentsDateTime(method.deletedAt),
            'LL/dd/yyyy • t ZZZZ'
          )
        : '',
      deletedBy,
      deleted: !!method.deletedAt
    };
  }, [deletedBy, method]);

  return { data };
};
